import { render, staticRenderFns } from "./CoinStatus.vue?vue&type=template&id=df057348&scoped=true&"
import script from "./CoinStatus.vue?vue&type=script&lang=ts&"
export * from "./CoinStatus.vue?vue&type=script&lang=ts&"
import style0 from "./CoinStatus.vue?vue&type=style&index=0&id=df057348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df057348",
  null
  
)

export default component.exports